<template>
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.606 16.4838L18.1646 16.075C16.8638 15.706 15.9557 14.4238 15.9556 12.9562C15.9556 12.9562 15.9555 11.176 12.7279 11.1759C9.50139 11.1759 9.5002 12.9562 9.5002 12.9562C9.5002 14.4238 8.59206 15.706 7.29126 16.075L5.8499 16.4838C3.88566 17.0409 1.96891 15.4219 1.96883 13.2057C1.96883 11.874 2.26643 10.5402 3.134 9.6044C4.59429 8.02892 7.55626 5.83524 12.7279 5.83526C17.8996 5.83528 20.8616 8.02893 22.3219 9.60437C23.1894 10.5402 23.487 11.874 23.487 13.2057C23.487 15.4219 21.5702 17.0409 19.606 16.4838Z" stroke="white" stroke-linecap="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconCall'
}
</script>
